<div (click)="handleTriggerClick($event)">
  @if (customTriggerTemplateRef && customValueTemplateRef) {
    @if (hasValue) {
      <ng-container
        [ngTemplateOutlet]="customValueTemplateRef"
        [ngTemplateOutletContext]="{
          startWeek: selectedStartWeek,
          endWeek: selectedEndWeek,
          hasError: hasError,
        }"
      />
    } @else {
      <ng-container
        [ngTemplateOutlet]="customTriggerTemplateRef"
        [ngTemplateOutletContext]="{
          hasError: hasError,
        }"
      />
    }
  } @else {
    <ng-container [ngTemplateOutlet]="defaultTriggerAndValueTemplate" />
  }
</div>

<p-popover #weekRangePicker>
  <div class="grid w-[26rem] grid-cols-1" (click)="$event.stopPropagation()">
    <ng-container *ngTemplateOutlet="calendarTemplate" />
    <ng-container *ngTemplateOutlet="controlsTemplate" />
  </div>
</p-popover>

<ng-template #calendarTemplate>
  <div>
    <!-- year selection -->
    <div class="mb-3 flex items-center justify-between gap-1">
      <ng-select
        class="w-[6rem]"
        [items]="years"
        [(ngModel)]="calendarYear"
        [clearable]="false"
        [placeholder]="calendarYear"
        (change)="changeCurrentYear($event)"
      />

      <div class="flex">
        <p-button
          variant="text"
          severity="contrast"
          (click)="generatePreviousYearCalendar(); $event.stopPropagation()"
          pTooltip="Previous year"
          tooltipPosition="top"
        >
          <ng-template #icon>
            <svg-icon src="assets/icons/general/chevron-left.svg" />
          </ng-template>
        </p-button>
        <p-button
          variant="text"
          severity="contrast"
          (click)="generateNextYearCalendar(); $event.stopPropagation()"
          pTooltip="Next year"
          tooltipPosition="top"
        >
          <ng-template #icon>
            <svg-icon src="assets/icons/general/chevron-right.svg" />
          </ng-template>
        </p-button>
      </div>
    </div>

    <p class="p-1 text-xs font-semibold">Weeks</p>

    <!-- weeks of year -->
    <div class="grid grid-cols-12">
      <!-- weeks -->
      @for (w of weeks; track w) {
        <button
          [class]="getWeekStyle(w)"
          (click)="
            selectWeek({ week: w, year: calendarYear });
            $event.stopPropagation()
          "
        >
          {{ w }}
        </button>
      }
    </div>
  </div>
</ng-template>

<ng-template #controlsTemplate>
  <div class="mt-3 flex justify-end gap-2">
    <p-button
      variant="text"
      severity="contrast"
      (click)="clearWeeks()"
      label="Clear"
    />
    <p-button (click)="applyWeekRange()" label="Apply" />
  </div>
</ng-template>

<ng-template #defaultTriggerAndValueTemplate>
  <div class="flex min-w-[17rem] items-center gap-1">
    <div
      class="ag1-week-range-picker-input grid min-h-[2.75rem] grow select-none grid-cols-[auto_auto_auto] items-center justify-start gap-x-0.5 whitespace-nowrap rounded border border-slate-300 px-3 py-2 outline-none"
      [class]="{
        'cursor-not-allowed': disabled || readonly,
        'bg-slate-50': disabled,
        'text-slate-400': disabled,
        'cursor-pointer': !disabled || !readonly,
        'bg-white': !disabled || !readonly,
        'pointer-events-none': readonly,
        'border-dashed': readonly,
        '!bg-[#f9f9f9]': readonly,
        '!text-slate-800': readonly,
      }"
    >
      @if (!startWeek || !endWeek) {
        {{ placeholder }}
      }
      @if (startWeek && endWeek) {
        @if (isRangeSelection) {
          <div class="grid grid-cols-[1fr_auto_1fr] items-center gap-1">
            <div>{{ selectedStartWeek }}</div>
            <div>{{ separator }}</div>
            <div>{{ selectedEndWeek }}</div>
          </div>
        }
        @if (isSingleSelection) {
          <div class="col-span-3 w-full">{{ selectedStartWeek }}</div>
        }
      }
    </div>

    <p-button [disabled]="disabled || readonly">
      <ng-template #icon>
        <svg-icon src="assets/icons/general/calendar.svg" />
      </ng-template>
    </p-button>
  </div>
</ng-template>
